import React from 'react'
import { Button, Typography } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import CloseButton from 'redesign/components/atoms/Buttons/CloseButton'
import { ActionButtonsContainer, Container } from './styles'
import type { CommentModalHeaderProps } from './types'

const CommentModalHeader: React.FC<CommentModalHeaderProps> = ({ headerLabel, showSendButton, onClose, onClick }) => {
  const { t } = useFavurTranslation()

  return (
    <Container>
      <Typography variant="subtitle1">{headerLabel}</Typography>
      <ActionButtonsContainer>
        {showSendButton && <Button onClick={onClick}>{t('button.send')}</Button>}
        <CloseButton onClick={onClose} />
      </ActionButtonsContainer>
    </Container>
  )
}

export default CommentModalHeader
